import { displayNewAppointmentForm } from './DisplayNewAppointmentFormAdapter';
import { displayNewMessageForm } from './DisplayNewMessageFormAdapter';
import { displayReplyForm } from './DisplayReplyFormAdapter';
import { getRecurrence, getSeriesId } from './ReadRecurrenceAdapter';
import { displayAppointmentForm } from '../CommonAdapters/DisplayAppointmentFormAdapter';
import { displayMessageForm } from '../CommonAdapters/DisplayMessageFormAdapter';
import { getReadInternetHeaders as getInternetHeaders } from '../CommonAdapters/GetInternetHeadersAdapter';
import { isReadAddinPinned as isAddinPinned } from '../CommonAdapters/IsAddinPinnedAdapter';
import { getReadItemId as getItemId } from '../CommonAdapters/ItemIdAdapter';
import { isSharedItemForRead } from '../CommonAdapters/SharedItemAdapter';
import { getSharedProperties } from '../CommonAdapters/SharedPropertiesAdapter';
import { MessageReadAdapter } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { findInlineComposeViewState } from 'owa-mail-compose-store';
import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import ReadingPaneStore from 'owa-mail-reading-pane-store/lib/store/schema/ReadingPaneStore';
import store from 'owa-mail-reading-pane-store/lib/store/Store';
import { getFocusedItemPart } from 'owa-mail-reading-pane-store/lib/utils/focusedItemPartUtils';
import Item from 'owa-service/lib/contract/Item';
import { select } from 'satcheljs/lib/legacy';
import {
    addNotificationMessage,
    removeNotificationMessage,
    getNotificationMessageIds,
} from '../NotificationMessageAdapters/ReadNotificationMessageAdapter';

export interface ReadAdapterCreatorState {
    store: ReadingPaneStore;
}

const getItem = (item: Item) => (): Item => {
    return item;
};

const isItemSelected = (
    viewState: ItemPartViewState,
    state?: ReadAdapterCreatorState
) => (): boolean => {
    return viewState.isConversationItemPart
        ? getFocusedItemPart({
              conversationReadingPaneState: state.store.conversationReadingPaneViewState,
          }) == viewState
        : true;
};

const isInlineComposeOpen = (viewState: ItemPartViewState, item: Item) => (): boolean => {
    const conversationId =
        viewState.isConversationItemPart && item.ConversationId ? item.ConversationId.Id : null;
    return !!findInlineComposeViewState(conversationId);
};

export let createMailReadAdapter = select<ReadAdapterCreatorState>({
    store: () => store,
})(function createMailReadAdapter(
    item: Item,
    viewState: ItemPartViewState,
    state?: ReadAdapterCreatorState
): MessageReadAdapter {
    return {
        getItem: getItem(item),
        getItemId: getItemId(item),
        addNotificationMessage: addNotificationMessage(viewState),
        removeNotificationMessage: removeNotificationMessage(viewState),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        mode: ExtensibilityModeEnum.MessageRead,
        displayMessageForm,
        displayNewMessageForm,
        displayNewAppointmentForm,
        displayReplyForm,
        displayAppointmentForm,
        isAddinPinned,
        isItemSelected: isItemSelected(viewState, state),
        isInlineComposeOpen: isInlineComposeOpen(viewState, item),
        isSharedItem: isSharedItemForRead(item),
        getSharedProperties: getSharedProperties(item),
        getRecurrence: getRecurrence(item),
        getSeriesId: getSeriesId(item),
        getInternetHeaders: getInternetHeaders(item),
    };
});

export default createMailReadAdapter;
